import { TabProxy } from "encampy";

export async function automateSDLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#txtUsername", { timeout: 10000 });

  // Type in the username
  await tab.type("input#txtUsername", username);

  // Type in the password
  await tab.type("input#txtPassword", password);

  // Click Login
  await tab.click("#btnLogin");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
